import getMessage from 'src/background/utils/i18n.utils';
import { setErrorMessage, setSuccessMessage, } from '@popup/multichain/actions/message.actions';
import { navigateTo, navigateToWithParams, } from '@popup/multichain/actions/navigation.actions';
import { setTitleContainerProperties } from '@popup/multichain/actions/title-container.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import { IncomingOutgoingItemComponent } from '@popup/steem/pages/app-container/home/delegations/incoming-outgoing-page/incoming-outgoing-item.component/incoming-outgoing-item.component';
import CurrencyUtils from '@popup/steem/utils/currency.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import FormatUtils from 'src/utils/format.utils';
const IncomingOutgoingPage = ({ delegationType, delegations, globalProperties, currencyLabels, totalPendingOutgoingUndelegation, available, setTitleContainerProperties, }) => {
    let header = '';
    switch (delegationType) {
        case DelegationType.INCOMING:
            header = 'popup_html_total_incoming';
            break;
        case DelegationType.OUTGOING:
            header = 'popup_html_total_outgoing';
            break;
    }
    const [totalHP, setTotalHP] = useState('...');
    const [delegationList, setDelegationList] = useState([]);
    const [pendingUndelegationsList, setPendingList] = useState([]);
    useEffect(() => {
        setTitleContainerProperties({
            title: delegationType,
            isBackButtonEnabled: true,
        });
        let totalVests = 0;
        let totalPendingOutgoingUndelegation = 0;
        setPendingList(delegations.pendingOutgoingUndelegation);
        if (delegationType === DelegationType.INCOMING) {
            totalVests = delegations.incoming.reduce((prev, cur) => {
                return (prev + Number(cur.vesting_shares.toString().replace(' VESTS', '')));
            }, 0);
            setDelegationList(delegations.incoming);
        }
        else if (delegationType === DelegationType.OUTGOING) {
            totalVests = delegations.outgoing.reduce((prev, cur) => {
                return (prev + Number(cur.vesting_shares.toString().replace(' VESTS', '')));
            }, 0);
            totalPendingOutgoingUndelegation =
                delegations.pendingOutgoingUndelegation.reduce((prev, cur) => {
                    return prev + cur.vesting_shares;
                }, 0);
            setDelegationList(delegations.outgoing);
        }
        setTotalHP(FormatUtils.toSP(totalVests.toString(), globalProperties));
    }, [delegations]);
    return (React.createElement("div", { className: "incoming-outgoing-page", "data-testid": `${Screen.INCOMING_OUTGOING_PAGE}-page` },
        delegationType === DelegationType.OUTGOING &&
            totalPendingOutgoingUndelegation > 0 && (React.createElement("div", { className: "pending-disclaimer" }, getMessage('popup_html_undelegation_pending_until_message'))),
        React.createElement("div", { className: "list-panel" },
            delegationType === DelegationType.OUTGOING &&
                totalPendingOutgoingUndelegation > 0 && (React.createElement("div", { className: "panel pending-undelegations" },
                React.createElement("div", { className: "total" },
                    React.createElement("div", { className: "label" }, getMessage('popup_html_total_pending_undelegate')),
                    React.createElement("div", { className: "value" },
                        FormatUtils.withCommas(totalPendingOutgoingUndelegation.toString()),
                        ' ',
                        currencyLabels.sp)),
                React.createElement("div", { className: "list" }, pendingUndelegationsList.map((pendingUndelegation, index) => (React.createElement(IncomingOutgoingItemComponent, { key: index, delegationType: delegationType, amount: pendingUndelegation.vesting_shares.toString(), expirationDate: pendingUndelegation.expiration_date })))))),
            React.createElement("div", { className: "panel" },
                React.createElement("div", { className: "total" },
                    React.createElement("div", { className: "label" }, getMessage(header)),
                    React.createElement("div", { className: "value" },
                        FormatUtils.withCommas(totalHP.toString()),
                        " ",
                        currencyLabels.sp)),
                React.createElement("div", { className: "list" }, delegationList.map((delegation, index) => (React.createElement(IncomingOutgoingItemComponent, { key: index, delegationType: delegationType, username: delegationType === DelegationType.INCOMING
                        ? delegation.delegator
                        : delegation.delegatee, amount: delegation.vesting_shares, expirationDate: delegation.expiration_date, maxAvailable: available }))))))));
};
const mapStateToProps = (state) => {
    var _a;
    return {
        activeAccount: state.steem.activeAccount,
        delegationType: state.navigation.stack[0].params
            .delegationType,
        totalPendingOutgoingUndelegation: state.navigation.stack[0].params.totalPendingOutgoingUndelegation,
        delegations: state.steem.delegations,
        globalProperties: state.steem.globalProperties.globals,
        currencyLabels: CurrencyUtils.getCurrencyLabels((_a = state.steem.activeRpc) === null || _a === void 0 ? void 0 : _a.testnet),
        available: state.navigation.stack[0].params.available,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
    navigateTo,
    setErrorMessage,
    setSuccessMessage,
    setTitleContainerProperties,
});
export const IncomingOutgoingPageComponent = connector(IncomingOutgoingPage);
